<template>
  <div>
    <Annuaire />
  </div>
</template>

<script>
//import Annuaire from './components/Annuaire.vue'
import Annuaire from './components/AnnuaireBis.vue'

export default {
  name: 'App',
  components: {
    Annuaire
  }
}
</script>

<style>
@import "./../node_modules/bootstrap/dist/css/bootstrap.css";
@import "./../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap');

html, body {
  font-family: 'Roboto', sans-serif;
}

* {
  font-family: 'Roboto', sans-serif;
}

</style>
